import { FC, useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import axios from '../../../sharedModules/utils/axios.utils';

const XoiJobDetailPage: FC = () => {
  const { xoiJobId } = useParams<{ xoiJobId: string }>();

  const [errorMessage, setErrorMessage] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);

  const [photos, setPhotos] = useState<any[]>();

  const fetchPhotosForJob = async () => {
    setLoading(true);
    try {
      const response: any = await axios.get(`/photo_proposals/photo_proposals/${xoiJobId}`);
      setPhotos(response.data.photos);
      setErrorMessage('');
    } catch (error) {
      setErrorMessage('Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPhotosForJob();
  }, []);

  return (
    <>
      <p>XOI Job</p>
      {loading && <p>Loading...</p>}
      {errorMessage && <p>{errorMessage}</p>}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '12px' }}>
        {photos?.map((photo) => (
          <div key={photo.id}>
            <img
              src={photo.url}
              alt={`Uploaded by ${photo.uploader}`}
              style={{ width: '100%', height: '250px', objectFit: 'cover', borderRadius: '4px' }}
            />
            <p style={{ fontSize: '11px', color: '#666', margin: '4px 0 0', wordBreak: 'break-all' }}>{photo.id}</p>
            <p style={{ fontSize: '11px', color: '#666', margin: '2px 0 0' }}>
              {photo.uploader} &middot; {new Date(photo.uploaded_at).toLocaleString()}
            </p>
          </div>
        ))}
      </div>
    </>
  );
};

export default XoiJobDetailPage;
